import { useEffect, useState } from "react";

// Most AI generations and transcriptions land well under 90s. Past that, the
// fake progress meters have nothing honest left to say — callers use this to
// swap to indeterminate progress + "still working" copy instead of sitting
// frozen at 99%. Resets whenever the wait ends.
export const useStillWorking = (active: boolean, delayMs = 90_000): boolean => {
  const [stillWorking, setStillWorking] = useState(false);

  useEffect(() => {
    if (!active) {
      setStillWorking(false);
      return;
    }
    const id = setTimeout(() => setStillWorking(true), delayMs);
    return () => clearTimeout(id);
  }, [active, delayMs]);

  return stillWorking;
};
